import { Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Row, Table } from "reactstrap";
import { Btn, H2, H4, H6, P } from "../../AbstractElements";
import { formatMontant, URL_API } from "../../utils/helper/helpers"
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import SweetAlert from 'sweetalert2';
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { formatDate, formatPrice, generateRandomNumber, getWeekOfMonth, itemHasPermission, supprimerBalises, truncateText } from "../../utils/helper/helpers";
import '../../utils/helper/style.css';
import useCaisseListe, { CaisseSummary, CardCaisse, deleteCaisse } from "./apiCaisse";
import { Link } from "react-router-dom";
import html2pdf from "html2pdf.js";
import { EditerCaisse } from "../../utils/helper/modal";

type Caisses = { [key: string]: any }

const GestCaisse = () => {

    const today = new Date();
    const [selectedYear, setSelectedYear] = useState<number | null>(today.getFullYear());
    const [selectedMonth, setSelectedMonth] = useState<number | null>(today.getMonth() + 1);
    
    const [filterText, setFilterText] = useState("");
    const [filteredItems, setFilteredItems] = useState<Caisses[]>([]);
    const [refresh, setRefresh] = useState(false);
    const caisse = useCaisseListe(refresh) || [];
    const [show, setShow] = useState(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false); // Gère l'état d'envoi
    const [showExport, setShowExport] = useState(true);
    const pdfRef = useRef<HTMLDivElement>(null);
    const Token = JSON.parse(localStorage.getItem("login")!);

    const [data, setData] = useState({
        montant: 0,
        type: '',
        description: '',
        id: null
    });
    const [erreur, setErreur] = useState({
        montant: '',
        type: '',
        description: '',
        id: null
    });

    //Modal de modification
    const [showModal, setShowModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState<any | null>(null);
    const handleEditClick = (item: any) => {
        setSelectedItem(item);
        setShowModal(true);
    };

    const toggleModal = () => setShowModal(prev => !prev);

    // Récupération initiale
    useEffect(() => {
        const savedFilterText = localStorage.getItem("filterText_caisse") || "";
        const savedSelectedMonth = localStorage.getItem("selectedMonth_caisse");
        const savedSelectedYear = localStorage.getItem("selectedYear_caisse");

        setFilterText(savedFilterText);
        setSelectedMonth(savedSelectedMonth ? parseInt(savedSelectedMonth) : today.getMonth() + 1);
        setSelectedYear(savedSelectedYear ? parseInt(savedSelectedYear) : today.getFullYear());
    }, []);

    // Sauvegarde à chaque changement
    useEffect(() => {
        localStorage.setItem("filterText_caisse", filterText);
        localStorage.setItem("selectedMonth_caisse", selectedMonth ? selectedMonth.toString() : "");
        localStorage.setItem("selectedYear_caisse", selectedYear ? selectedYear.toString() : "");
    }, [filterText, selectedMonth, selectedYear]);

    const clearFilters = () => {
        localStorage.removeItem("filterText_caisse");
        localStorage.removeItem("selectedMonth_caisse");
        localStorage.removeItem("selectedYear_caisse");

        setFilterText("");
        setSelectedMonth(today.getMonth() + 1);
        setSelectedYear(today.getFullYear());
    };

    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        
        const formattedValue = name === "montant" ? formatMontant(value) : value;

        setData((prevState) => ({
            ...prevState,
            [name]: formattedValue
        }));
    };

    const handleSubmitData = (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);
        const url = `${URL_API}/caisse/store`

        axios.post(url, { ...data }, {
            headers: {
                Authorization: `Bearer ${Token}`
            }
        }).then(response => {

            if (response.data.success) {
                toast.success("Enrégistrement éffectué avec succès");
                setRefresh((prev) => !prev);
                clearDataForm();
            }

        }).catch(error => {
            toast.info("Oups !! Erreur de modification des données");
            if (error.response.status === 422) {

                setErreur(error.response.data.message);
            }
        })
        setRefresh((prev) => !prev);
        setIsSubmitting(false);
    }

    const Confirmation = ({ id, type }: { id: number, type: string }) => {
        SweetAlert.fire({
            title: 'Êtes-vous sûr?',
            text: "De Vouloir Supprimer cet element ??",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, Supprimer !'
        }).then((result) => {
            if (result.isConfirmed) {
                deleteCaisse({ id: id }, () => setRefresh(!refresh));
            }
        });
    };

    const handleCKEditorChange = (event: any, editor: any) => {
        const data = editor.getData();
        setData((prevState) => ({
            ...prevState,
            description: data
        }));
    };

    const clearDataForm = () => {
        setData({
            montant: 0,
            type: '',
            description: '',
            id: null
        });
        setErreur({
            montant: '',
            type: '',
            description: '',
            id: null
        });
        setShow(false);
    }

    useEffect(() => {
        const filtered = caisse.filter((item) => {
            const date = new Date(item.date_mouvement);
            const matchMonth = selectedMonth ? (date.getMonth() + 1 === selectedMonth) : true;
            const matchYear = selectedYear ? (date.getFullYear() === selectedYear) : true;
            const matchSearch = item.descriptions?.toLowerCase().includes(filterText.toLowerCase()) || false;

            return matchMonth && matchSearch;
            // return matchMonth && matchYear && matchSearch;
        });

        const sorted = filtered.sort((a, b) => {
            const dateA = new Date(a.created_at).getTime();
            const dateB = new Date(b.created_at).getTime();
            return dateA - dateB; // croissant = ancien → récent
        });

        setFilteredItems(sorted);
        // setFilteredItems(filtered);
        setTimeout(() => {
            setIsLoading(false);
        }, 2000);
    }, [caisse, filterText, selectedMonth, selectedYear, refresh]);

    const generatePDF = () => {
        setShowExport(false)
        const element = pdfRef.current;
        const name_document = generateRandomNumber(100000, 999999);
        if (element) {
            html2pdf()
                .from(element)
                .save(`synthese_caisse${name_document}.pdf`)
                .then(() => setShowExport(true))
                .catch(() => setShowExport(true));
        }
    };
    console.log('filteredItems', filteredItems);
    return (
        <div className='page-body'>
            {isLoading ? (
                <div className="loading-container">
                    <div className="spinner-container">
                        <div className="spinner"></div>
                        <span className="loading-text">Chargement de la plateforme...</span>
                    </div>
                </div>
            ) : ( 
                <>
                    <Breadcrumbs mainTitle="Sortie & Entrée" parent="Caisse" />
                    <Container fluid>

                        <Row>
                            <Col md="12">
                                <CardCaisse value={caisse} />
                            </Col>
                            <Col md="8">
                                <Card>
                                    <CardBody>
                                        <Row className="mb-3 items-center">
                                            <Col sm="3">
                                                {/* <Label>Recherche :</Label> */}
                                                <div className="flex items-center gap-2">
                                                <Input
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                                                    type="search"
                                                    placeholder="Recherche..."
                                                    value={filterText}
                                                />
                                                </div>
                                            </Col>

                                            <Col sm="3">
                                                {/* <Label>Mois :</Label> */}
                                                <Input
                                                type="select"
                                                value={selectedMonth || ""}
                                                className="form-control"
                                                onChange={(e) => setSelectedMonth(e.target.value ? parseInt(e.target.value) : null)}
                                                >
                                                <option value="">Tous les mois</option>
                                                <option value="1">Janvier</option>
                                                <option value="2">Février</option>
                                                <option value="3">Mars</option>
                                                <option value="4">Avril</option>
                                                <option value="5">Mai</option>
                                                <option value="6">Juin</option>
                                                <option value="7">Juillet</option>
                                                <option value="8">Août</option>
                                                <option value="9">Septembre</option>
                                                <option value="10">Octobre</option>
                                                <option value="11">Novembre</option>
                                                <option value="12">Décembre</option>
                                                </Input>
                                            </Col>

                                            <Col sm="3">
                                                {/* <Label>Année :</Label> */}
                                                <Input
                                                type="select"
                                                value={selectedYear || ""}
                                                className="form-control"
                                                onChange={(e) => setSelectedYear(e.target.value ? parseInt(e.target.value) : null)}
                                                >
                                                <option value="">Toutes les années</option>
                                                {Array.from({ length: 10 }, (_, i) => {
                                                    const year = new Date().getFullYear() - i;
                                                    return (
                                                    <option key={year} value={year}>
                                                        {year}
                                                    </option>
                                                    );
                                                })}
                                                </Input>
                                            </Col>

                                            <Col sm="3" className="d-flex align-items-end">
                                                <button
                                                className="btn btn-danger w-100"
                                                onClick={clearFilters}
                                                disabled={!filterText && !selectedMonth && !selectedYear}
                                                >
                                                <i className="fa fa-trash me-1" />
                                                Réinitialiser
                                                </button>
                                            </Col>
                                            </Row>
                                        {/* <Row>
                                            <Col sm="6">
                                                <div className="dataTables_filter d-flex align-items-center">
                                                    <Label className="me-2">{SearchTableButton}:</Label>
                                                    <Input
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                                                        type="search"
                                                        value={filterText}
                                                    />
                                                </div>
                                            </Col>
                                            <Col sm="6">
                                                <div className="dataTables_filter d-flex align-items-center">
                                                    <Label className="me-2">Filtrer par mois:</Label>
                                                    <Input
                                                        name="type"
                                                        value={selectedMonth || ''}
                                                        onChange={handleMonthChange}
                                                        type="select"
                                                        className="form-control"
                                                    >
                                                        <option value="">Mois actuel</option>
                                                        <option value="1">Janvier</option>
                                                        <option value="2">Février</option>
                                                        <option value="3">Mars</option>
                                                        <option value="4">Avril</option>
                                                        <option value="5">Mai</option>
                                                        <option value="6">Juin</option>
                                                        <option value="7">Juillet</option>
                                                        <option value="8">Août</option>
                                                        <option value="9">Septembre</option>
                                                        <option value="10">Octobre</option>
                                                        <option value="11">Novembre</option>
                                                        <option value="12">Décembre</option>
                                                    </Input>
                                                </div>
                                            </Col>
                                        </Row> */}
                                    </CardBody>
                                </Card>
                                <div ref={pdfRef}>

                                    <Card className="invoice-card">
                                        <CardBody className="invoice-table pt-0 checkbox-checked">
                                            <H2 className="fw-bolder text-center text-uppercase mb-3 f-w-13">
                                                Mouvement Entrée & Sortie <br />
                                                <span className="text-capitalize f-w-400 f-25">
                                                    {selectedMonth
                                                        ? new Intl.DateTimeFormat("fr-FR", { month: "long", year: "numeric" }).format(
                                                            new Date(new Date().getFullYear(), selectedMonth - 1, 1) // Ajuste le mois (1-12)
                                                        )
                                                        : new Intl.DateTimeFormat("fr-FR", { month: "long", year: "numeric" }).format(new Date())}
                                                </span> <br />                                      {
                                                    showExport == true ? (
                                                        <>
                                                            <Btn color="light-dark " onClick={generatePDF} className="btn btn-xs mx-1 p-1 px-3 for-light">
                                                                <i className="fa fa-download"></i> Télécharger
                                                            </Btn>
                                                            <Btn color="light-light " onClick={generatePDF} className="btn btn-xs mx-1 p-1 px-3 for-dark">
                                                                <i className="fa fa-download"></i> Télécharger
                                                            </Btn>
                                                        </>
                                                    ) : (
                                                        null
                                                    )
                                                }
                                            </H2>
                                            <Table responsive id="all-invoice">
                                                <thead className="bg-info">
                                                    <tr>
                                                        <th className="text-white">No</th>
                                                        <th className="text-white ps-4">Semaine</th>
                                                        <th className="text-white ">Descriptions</th>
                                                        <th className="text-white ">Montant</th>
                                                        <th className="text-white ">Type</th>
                                                        <th className="text-white ">Solde</th>
                                                        {
                                                            (itemHasPermission('super admin') || itemHasPermission('gest. caisse ecriture')) && (
                                                                showExport == true ? (
                                                                    <th className="text-white ">Actions</th>
                                                                ) : (
                                                                    null
                                                                )
                                                            )

                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredItems.map((item, index) => (

                                                        <tr key={index}>
                                                            {
                                                                item.type === "Entrée" ? (
                                                                    <>
                                                                        <th scope='row'>
                                                                            <span className="fw-bold">
                                                                                #{index + 1}
                                                                            </span>
                                                                        </th>
                                                                        <td>
                                                                            <div className="d-flex align-items-center gap-2">
                                                                                <div className="flex-shrink-0">
                                                                                    <i className="icofont icofont-ui-calendar f-40 text-success"></i>
                                                                                </div>
                                                                                <div className="flex-grow-1">
                                                                                    <Link to="#">
                                                                                        <H6 className="f-w-500">Semaine {getWeekOfMonth(item.date_mouvement)}</H6>
                                                                                    </Link>
                                                                                    <span className="text-success text-capitalize f-w-400 f-13">  {formatDate(item.date_mouvement)} </span>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <span style={{ fontSize: '13px' }} dangerouslySetInnerHTML={{ __html: truncateText(supprimerBalises(item.descriptions), 25) }}>
                                                                            </span>
                                                                        </td>
                                                                        <td>
                                                                            <span className="text-capitalize">
                                                                                {formatPrice(item.montant)}
                                                                            </span>
                                                                        </td>
                                                                        <td>
                                                                            <Btn className="btn btn-xs btn-light-success" onClick={() => Confirmation({ id: item.id, type: "changeStatus" })}>
                                                                                {item.type}
                                                                            </Btn>
                                                                        </td>
                                                                        <td>
                                                                            {
                                                                                item.solde < 0 ? (
                                                                                    <span className="text-danger text-capitalize">
                                                                                        {formatPrice(item.solde)}
                                                                                    </span>
                                                                                ) : (
                                                                                    <span className="text-capitalize">
                                                                                        {formatPrice(item.solde)}
                                                                                    </span>
                                                                                )
                                                                            }

                                                                        </td>
                                                                        <td>
                                                                            {
                                                                                (itemHasPermission('super admin') || itemHasPermission('gest. caisse ecriture')) && (
                                                                                    showExport == true ? (
                                                                                        <>
                                                                                            <Btn className='bg-info btn-xs mx-1 my-1' onClick={() => handleEditClick(item)}>
                                                                                                <i className='fa fa-pencil'></i>
                                                                                            </Btn>
                                                                                            <Btn className='bg-danger btn-xs mx-1 my-1' onClick={() => Confirmation({ id: item.id, type: 'supprimer' })}>
                                                                                                <i className='fa fa-trash'></i>
                                                                                            </Btn>
                                                                                        </>
                                                                                    ) : (
                                                                                        null
                                                                                    )
                                                                                )

                                                                            }
                                                                        </td>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <th scope='row'>
                                                                            <span className="fw-bold">
                                                                                #{index + 1}
                                                                            </span>
                                                                        </th>
                                                                        <td>
                                                                            <div className="d-flex align-items-center gap-2">
                                                                                <div className="flex-shrink-0">
                                                                                    <i className="icofont icofont-ui-calendar f-40 text-danger"></i>
                                                                                </div>
                                                                                <div className="flex-grow-1">
                                                                                    <Link to="#">
                                                                                        <H6 className="f-w-500">Semaine {getWeekOfMonth(item.date_mouvement)}</H6>
                                                                                    </Link>
                                                                                    <span className="text-danger text-capitalize f-w-400 f-13">  {formatDate(item.date_mouvement)} </span>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <span className="text-danger" style={{ fontSize: '13px' }} dangerouslySetInnerHTML={{ __html: truncateText(supprimerBalises(item.descriptions), 25) }}>
                                                                            </span>
                                                                        </td>
                                                                        <td>
                                                                            <span className="text-danger text-capitalize">
                                                                                {formatPrice(item.montant)}
                                                                            </span>
                                                                        </td>
                                                                        <td>
                                                                            <Btn className="btn btn-xs btn-light-danger" onClick={() => Confirmation({ id: item.id, type: "changeStatus" })}>
                                                                                {item.type}
                                                                            </Btn>
                                                                        </td>
                                                                        <td>
                                                                            {
                                                                                item.solde < 0 ? (
                                                                                    <span className="text-danger text-capitalize">
                                                                                        {formatPrice(item.solde)}
                                                                                    </span>
                                                                                ) : (
                                                                                    <span className="text-capitalize">
                                                                                        {formatPrice(item.solde)}
                                                                                    </span>
                                                                                )
                                                                            }
                                                                        </td>
                                                                        <td>

                                                                            {
                                                                                (itemHasPermission('super admin') || itemHasPermission('gest. caisse ecriture')) && (
                                                                                    showExport == true ? (
                                                                                        <>
                                                                                            <Btn className='bg-info btn-xs mx-1 my-1' onClick={() => handleEditClick(item)} >
                                                                                            {/* <Btn className='bg-info btn-xs mx-1 my-1' onClick={() => editerCaisses({ id: item.id })}> */}
                                                                                                <i className='fa fa-pencil'></i>
                                                                                            </Btn>
                                                                                            <Btn className='bg-danger btn-xs mx-1 my-1' onClick={() => Confirmation({ id: item.id, type: 'supprimer' })}>
                                                                                                <i className='fa fa-trash'></i>
                                                                                            </Btn>
                                                                                        </>
                                                                                    ) : (
                                                                                        null
                                                                                    )
                                                                                )

                                                                            }

                                                                        </td>
                                                                    </>
                                                                )
                                                            }

                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>

                                        </CardBody>
                                    </Card>
                                </div>

                            </Col>
                            <Col md="4">
                                <Card>
                                    <CardBody>
                                        <Form onSubmit={handleSubmitData}>
                                            <H4 className="my-4 text-capitalize">
                                                Effectuer un mouvement dans la caisse
                                            </H4>

                                            <div className="product-info">
                                                <div className="product-group">
                                                    <Row>
                                                        <Col sm="6">
                                                            <FormGroup>
                                                                <Label>Type de mouvement</Label>
                                                                <Input
                                                                    name="type"
                                                                    value={data.type}
                                                                    onChange={changeHandler}
                                                                    type="select"
                                                                    className="form-control"
                                                                >
                                                                    <option value="">Selectionner...</option>
                                                                    <option value="Entrée">Entrée</option>
                                                                    <option value="Sortie">Sortie</option>
                                                                </Input>
                                                                {erreur.type && (
                                                                    <span className="text-danger">{erreur.type}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="6">
                                                            <FormGroup>
                                                                <Label>Montant</Label>
                                                                <Input
                                                                    placeholder="Entrer le montant"
                                                                    name="montant"
                                                                    value={data.montant}
                                                                    onChange={changeHandler}
                                                                    type="text"
                                                                />
                                                                {erreur.montant && (
                                                                    <span className="text-danger">{erreur.montant}</span>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm="12">
                                                            <FormGroup>
                                                                <Label>Descriptions</Label>

                                                                {show === false ? (

                                                                    <>
                                                                        <CKEditor
                                                                            editor={ClassicEditor}
                                                                            data={data.description}
                                                                            name='desc'
                                                                            onChange={handleCKEditorChange}
                                                                        />
                                                                        {erreur.description && (
                                                                            <span className="text-danger">{erreur.description}</span>
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <div className="text-dark text-center" dangerouslySetInnerHTML={{ __html: data.description }} onClick={() => setShow(!show)}></div>
                                                                )}
                                                            </FormGroup>

                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                            {
                                                (itemHasPermission('super admin') || itemHasPermission('gest. caisse ecriture')) && (
                                                    <div className="text-end">
                                                        <Btn color="info" type="submit" disabled={isSubmitting} >
                                                            {data.id == null ? (isSubmitting ? "En cours d'ajout..." : "Ajouter") : (isSubmitting ? "Sauvegarde en cours..." : "Sauvegarder")}
                                                        </Btn>
                                                        <Btn className="btn btn-danger ms-3" onClick={() => clearDataForm()}>
                                                            Annuler
                                                        </Btn>
                                                    </div>
                                                )
                                            }
                                        </Form>
                                    </CardBody>

                                </Card>
    
                                <CaisseSummary data={caisse.map(item => ({
                                                    id: item.id,
                                                    descriptions: item.descriptions || '',
                                                    date_mouvement: item.date_mouvement || '',
                                                    type: item.type as 'Entrée' | 'Sortie',
                                                    montant: item.montant ?? 0
                                                }))} />
                            </Col>
                        </Row>
                    </Container>
                    {
                        <EditerCaisse
                            isOpen={showModal}
                            item={selectedItem}
                            toggle={toggleModal}
                            onSuccess={() => {
                                setRefresh((prev) => !prev);
                            }}
                            onCancel={() => {
                                toast.info("Modification annulée.");
                            }}
                        />
                    }
                </>
            )}
        </div >

    )
}

export default GestCaisse
